import { render } from "./Favoris.vue?vue&type=template&id=ab817f9c"
import script from "./Favoris.vue?vue&type=script&lang=js"
export * from "./Favoris.vue?vue&type=script&lang=js"

import "./Favoris.vue?vue&type=style&index=0&id=ab817f9c&lang=css"

import exportComponent from "/Users/iammaham/Documents/JS/estate_soluce/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__